export const CANCELLATIONS = {
  flexible: {
    title: 'Cancellation flexible',
    description:
      'Your 1st rent will be 100% refunded if you cancel up to 30 days before the contract start date or you’ll get a 50% refund if you cancel up to 15 days.'
  },
  moderate: {
    title: 'Cancellation moderate',
    description:
      'Your 1st rent will be 100% refunded if you cancel up to 60 days before the contract start date or you’ll get a 50% refund if you cancel up to 30 days.'
  },
  strict: {
    title: 'Cancellation strict',
    description:
      'Your 1st rent will be 100% refunded if you cancel up to 90 days before the contract start date or you’ll get a 50% refund if you cancel up to 30 days.'
  },
  'super-strict': {
    title: 'Cancellation non-refundable',
    description:
      'This type of policy doesn’t allow any refunds, regardless of when you decide to cancel a confirmed booking.'
  }
};
